/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    priority: { description: '', type: 'variant', values: [ 'high' ] }
  },
  rules: [
    {
      if: { priority: 'high' },
      tokens: { backgroundColor: '#000000', iconColor: '#ffffff' }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#000000',
        borderWidth: 0,
        iconColor: '#ffffff'
      }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: 'transparent',
        borderColor: '#000000',
        borderWidth: 3,
        iconColor: '#000000'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#404040',
        borderWidth: 0,
        iconColor: '#666666'
      }
    },
    {
      if: { inactive: true, priority: 'high' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        iconColor: '#666666'
      }
    },
    {
      if: { inactive: true, priority: null },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: 'rgba(0, 0, 0, 0)'
      }
    }
  ],
  tokens: {
    backgroundColor: null,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 32,
    borderWidth: 0,
    iconColor: '#000000',
    iconSize: 20,
    mobileBackgroundColor: null,
    opacity: 1,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    shadow: null
  }
}
export default theme
